<template>
  <div>
    <div class="vue-uploader">
      <div
        :id="ossfile"
        class="file-item draggable-item"
        v-for="(val, index) in file"
        :key="index"
      >
        {{ val }}
        <span class="file-remove" @click="remove(index)">+</span>
        <!-- <div class="prograss" :style="{width: prograss[index].prograss + '%'}"></div> -->
      </div>
      <pre id="console"></pre>
    </div>
    <div id="container">
      <el-button
        size="medium"
        type="primary"
        :id="selectfiles"
        href="javascript:void(0);"
        class="btn"
        >选择文件</el-button
      >
      <el-button
        size="medium"
        type="primary"
        :id="postfiles"
        href="javascript:void(0);"
        class="btn uploadBtn"
        >开始上传</el-button
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import plupload from "plupload";
import XLSX from "xlsx";

export default {
  props: {
    multiple: {
      type: String,
      default: null,
    },
    multiSelection: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    dir: {
      type: String,
      default: "",
    },
    selectfiles: {
      type: String,
      default: null,
    },
    postfiles: {
      type: String,
      default: null,
    },
    ossfile: {
      type: String,
      default: null,
    },
    company_id: {
      type: String,
      default: null,
    },
    max_width: {
      type: Number,
      default: 0,
    },
    max_height: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: null,
    },
    beforeUpload: {
      type: Function,
    },
    onSuccess: {
      type: Function,
    },
    tableData: {
      type: Array,
    },
    tableHeader: {
      type: Array,
    },
    tableDataArr: {
      type: Array,
    },

    // imgurl: {
    //   type: String,
    //   default: null
    // }
  },
  data() {
    return {
      sign: [],
      file: [],
      prograss: [],
      url: [],
      arrUrl: [],
      filename: "", // 文件原始名
      load_text: "",
    };
  },
  computed: {
    logo() {
      return this.$store.state.logo;
    },
    plan() {
      return this.$store.state.plan;
    },
  },
  created() {},
  watch: {
    //    暂时不做
    logo(olds, news, index) {
      // console.log("watch=>logo",this.file, index)
      this.file.splice(index, 1);
      // this.remove()
    },
    plan(olds, news, index) {
      // console.log("watch=>plan",this.file, index)
      this.file.splice(index, 1);
      // this.remove()
    },
  },
  // beforeMount() {
  //   this.api()
  // },
  mounted() {
    this.upload();
  },
  methods: {
    // api请求签名
    async api() {
      const ossDir = `${this.$config.ossAppDir}/${this.dir}`;
      const res = await this.$api.getOssSign({ dir: ossDir });
      if (res) {
        // console.log('::UPLOAD->sign', res)
        this.sign = res;
        this.imgurl = res.host + "/";
      } else {
        this.$message.error("获取oss签名失败");
      }
    },
    handle_del_files() {
      this.file = [];
    },
    //  plupload 相关配置
    upload() {
      this.api();
      const uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4", // 制定上传方式
        browse_button: this.selectfiles, // dom元素的id
        multi_selection: this.multiSelection,
        container: document.getElementById("container"),
        // flash_swf_url : 'lib/plupload-2.1.2/js/Moxie.swf',
        // silverlight_xap_url : 'lib/plupload-2.1.2/js/Moxie.xap',
        url: "http://oss.aliyuncs.com",
        // 当Plupload初始化完成后触发监听函数参数
        init: {
          PostInit: () => {
            document.getElementById(this.postfiles).onclick = () => {
              console.log("::UPLOAD->postinit", uploader);
              this.set_upload_param(uploader, "", false);
              // this.handleData()
              return false;
            };
          },
          // 当文件添加到上传队列后触发监听函数参数
          FilesAdded: (up, files) => {
            // console.log('::FilesAdded->files', up.files, this.file, files)
            files.forEach((item) => {
              // console.log(item.name,"::Files")
              if (!this.file.includes(item.name)) {
                this.file.push(item.name);
                // this.prograss.push({
                //   name: item.name,
                //   prograss: 0
                // })
              }
            });
            // //  判断是否重复
            // if (!this.file.includes(files[0].name)) {
            //   this.file.push(files[0].name)
            //   this.prograss.push({
            //     name: files[0].name,
            //     prograss: 0
            //   })
            // }
            if (this.multiple === "false") {
              this.file = this.file.slice(0, 1);
              uploader.files = uploader.files.slice(0, 1);
            }
            if (this.multiple === "true") {
              console.log(
                this.file,
                uploader.files,
                "this.filethis.filethis.file"
              );
            }
          },
          //当前文件队列变化时触发
          QueueChanged(up) {
            console.log(up, ">>>>>>>>>>>>>upup");
          },
          // 上传前
          BeforeUpload: (up, file) => {
            console.log("::UPLOAD->before", file);
            this.$emit("before_upload", this.load_text);
            this.set_upload_param(up, file.name, true);
          },
          //  进度条
          // UploadProgress: (up, file) => {
          //   this.prograss.forEach(v => {
          //     if(v.name = file.name){
          //       v.prograss = file.percent
          //     }
          //   v.prograss = file.percent
          //   })
          // },
          // 上传完成
          FileUploaded: (up, file, info) => {
            console.log(up.files, "uploader.files");
            this.load_text = "";
            this.$message.success("上传成功");
            if (this.url.length) {
              this.url.forEach((val, index) => {
                const fileItem = file[index];
                this.$emit("return_url", {
                  url: this.imgurl + val.key,
                  filename: this.filename,
                  size: fileItem.size,
                  load_text: this.load_text,
                  title: this.title,
                });
              });
            } else {
              this.$emit("return_url", {
                url: this.imgurl + this.url.key,
                filename: this.filename,
                size: file.size,
                load_text: this.load_text,
                title: this.title,
              });
            }
          },
          Error: (up, args) => {
            this.$message.error("上传失败");
            this.$emit("return_url", "error");
          },
        },
      });
      uploader.init();
    },
    set_upload_param(up, filename, ret) {
      this.load_text = "加载中";
      this.filename = filename;
      const time = new Date().getTime() + Math.random() * 1000;
      let key;
      if (this.company_id) {
        key =
          this.sign.dir +
          this.company_id +
          "/" +
          time +
          "." +
          filename.split(".")[filename.split(".").length - 1];
      } else {
        key =
          this.sign.dir +
          time +
          "." +
          filename.split(".")[filename.split(".").length - 1];
      }
      const sign = this.sign;
      const new_multipart_params = {
        key,
        policy: sign.policy,
        OSSAccessKeyId: sign.accessid,
        success_action_status: "200", // 让服务端返回200,不然，默认会返回204
        signature: sign.signature,
      };
      // 设定缩放尺寸大小
      const resize = {
        width: this.max_width,
        height: this.max_height,
      };
      !resize.width && delete resize.width;
      !resize.height && delete resize.height;
      const options = {
        url: sign.host,
        resize,
        multipart_params: new_multipart_params,
      };
      if (JSON.stringify(resize) == "{}") {
        delete options.resize;
      }
      up.setOption(options)
      up.start()
      this.arrUrl = []
      let newkey
      const strAry = key.split('.');
      const len = strAry.length - 1
      strAry[len] = strAry[len].toLowerCase()
      newkey = strAry.join(".")
      if (this.multiple === 'true') {
       // 图片和视频
        if (newkey.includes('.ofd') || newkey.includes('.webp') || newkey.includes('.jpeg') || newkey.includes('.jpg') || newkey.includes('.png') || newkey.includes('.gif') || newkey.includes('.xls') || newkey.includes('.xlsx') || newkey.includes('.csv') || newkey.includes('.mp4') || newkey.includes('.pdf') || newkey.includes('.docx') || newkey.includes('.doc') || newkey.includes('.zip') || newkey.includes('.rar')) {
          this.arrUrl.push({ key })
          this.url = this.arrUrl[0]
        }
      } else {
        // 图片和视频
        if (newkey.includes('.ofd') || newkey.includes('.webp') || newkey.includes('.jpeg') || newkey.includes('.jpg') || newkey.includes('.png') || newkey.includes('.gif') || newkey.includes('.xls') || newkey.includes('.xlsx') || newkey.includes('.csv') || newkey.includes('.mp4') || newkey.includes('.pdf') || newkey.includes('.docx') || newkey.includes('.doc') || newkey.includes('.zip') || newkey.includes('.rar')) {
          this.arrUrl.push({ key })
          this.url = this.arrUrl[0]
        }
      }
    },
    //  移出文件
    remove(index) {
      this.file.splice(index, 1);
      this.$emit("remove_file");
    },
  },
};
</script>

<style lang='scss' scoped>
.btn {
  margin-top: 15px;
}
// .btn {
//   margin: {
//     top: 10px;
//   }
//   color: #fff;
//   background-color: #429efd;
//   border-color: #2e6da4;
//   display: inline-block;
//   padding: 4px 15px;
//   font-size: 12px;
//   font-weight: 400;
//   line-height: 1.42857143;
//   text-align: center;
//   white-space: nowrap;
//   text-decoration: none;
//   vertical-align: middle;
//   -ms-touch-action: manipulation;
//   touch-action: manipulation;
//   cursor: pointer;
//   -webkit-user-select: none;
//   -moz-user-select: none;
//   -ms-user-select: none;
//   user-select: none;
//   background-image: none;
//   border: 1px solid transparent;
//   border-radius: 4px;
// }
.uploadBtn {
  margin-left: 10px;
}
.el-button + .el-button {
  margin-left: 10px;
}
a.btn:hover {
  background-color: #3366b7;
}
.vue-uploader {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  min-height: 38px;
  // height: 40px;
  .file-item {
    position: relative;
    margin: {
      left: 10px;
      right: 10px;
    }
  }
  .file-remove {
    position: absolute;
    right: 4px;
    display: none;
    top: 4px;
    width: 20px;
    height: 20px;
    font-size: 20px;
    text-align: center;
    color: white;
    cursor: pointer;
    line-height: 18px;
    border-radius: 100%;
    transform: rotate(45deg);
    background: rgba(0, 0, 0, 0.5);
  }
  .file-item:hover .file-remove {
    display: block;
  }
  .prograss {
    transition: all 0.5s;
    border-radius: 4px;
    background-color: rgb(92, 184, 92);
    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.14902) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.14902) 50%,
      rgba(255, 255, 255, 0.14902) 75%,
      transparent 75%,
      transparent
    );
    background-size: 40px 40px;
    box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
    box-sizing: border-box;
    height: 4px;
    margin: {
      bottom: 5px;
    }
  }
}
.netbar_logo {
  width: 100%;
  height: 100px;
  // background: red;
  margin: {
    bottom: 15px;
  }
  div {
    width: 100px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>